import React from 'react';
import { Link } from 'react-router-dom';

function About() {
  return (
    <section className="about">
      <div className="container">
        <h1>🏢 About Aashman Technicals</h1>

        <div className="about-intro">
          <p>
            In 2019, Aashman Technicals Pvt. Ltd., located in Pune, emerged as a pioneering force in the electronics industry. As a dynamic and innovation-driven electronics design and development company, our commitment as a dedicated electronics solutions provider is driven by a vision to serve a diverse range of industry sectors through innovation-driven, cutting-edge technology solutions. We combine cutting-edge R&D capabilities with strong engineering expertise to deliver comprehensive solutions across multiple sectors, including industrial automation, consumer electronics, and application-specific AI/ML systems.
          </p>
        </div>

        <div className="about-section">
          <h2>👔 Leadership</h2>
          <div className="about-reasons">
            <div className="reason-item">
              <h4>👨🏻‍💼 Rahul Raverkar</h4>
              <p>
                Highly skilled business strategist and expert in business management with extensive experience at IIM, coupled with innovative technocrat background in leading multinational corporations.
              </p>
            </div>
            <div className="reason-item">
              <h4>👨🏻‍💼 Chetan Shinde</h4>
              <p>
                A seasoned product development expert with a background in multinational corporations, driven by a fervent passion for tailoring customized solutions and value engineering.
              </p>
            </div>
          </div>
        </div>

        <div className="about-grid">
          <div className="about-card">
            <h3>🎯 Mission</h3>
            <p>
              Collectively, our commitment is to create a positive impact in the lives of our customers through the provision of high-quality products and unparalleled services. We revolutionize the electronics industry through consistent delivery of groundbreaking products that enhance the way people live, work, and connect.
            </p>
          </div>

          <div className="about-card">
            <h3>👁️ Vision</h3>
            <p>
              Our driving force is to excel in all facets of our business, leading the marketplace, while making positive contributions to both society and the environment. We envision a future where intelligent electronics seamlessly integrate with human workflows globally.
            </p>
          </div>

          <div className="about-card">
            <h3>🎖️ Goals</h3>
            <p>
              We aspire to maintain the highest standards of integrity in every action we undertake, with a deep sense of personal accountability to fulfill our commitments and exceed our clients' expectations while contributing to a sustainable and technologically advanced future.
            </p>
          </div>
        </div>

        
        <div className="about-section">
          <h2>🛠️ Our Expertise</h2>
          <ul className="competencies-list">
            <li>✅ Electronics Design - Custom electronic solutions tailored to meet unique client needs</li>
            <li>✅ Prototyping - Rapid prototyping services for iterative development and testing</li>
            <li>✅ Embedded Systems - Development for IoT devices to industrial automation solutions</li>
            <li>✅ Software Development - Seamless integration and functionality with hardware expertise</li>
            <li>✅ Quality Assurance - Rigorous testing and quality control for highest standards</li>
            <li>✅ Product Development - Custom electronics development meeting unique specifications</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>🔧 Core Capabilities</h2>
          <ul className="competencies-list">
            <li>Custom electronic product development tailored to specific industry requirements</li>
            <li>Embedded systems and IoT applications for connected solutions</li>
            <li>Rapid prototyping and proof-of-concept solutions for faster innovation</li>
            <li>Application-based electronics for industrial automation</li>
            <li>Software integration and quality-assured testing frameworks</li>
            <li>End-to-end product development from concept to commercialization</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>⭐ Why Choose Aashman</h2>
          <div className="about-reasons">
            <div className="reason-item">
              <h4>💡 Innovation</h4>
              <p>
                We are at the forefront of electronics innovation, constantly pushing boundaries to create cutting-edge solutions that revolutionize industries.
              </p>
            </div>
            <div className="reason-item">
              <h4>👨‍💼 Expert Team</h4>
              <p>
                Our team consists of highly skilled engineers and designers with decades of experience and a passion for electronics and technology.
              </p>
            </div>
            <div className="reason-item">
              <h4>🔍 Quality Assurance</h4>
              <p>
                We follow a stringent quality control process to ensure that every product meets the highest standards with rigorous testing and validation.
              </p>
            </div>
            <div className="reason-item">
              <h4>🤝 Customer-Centric</h4>
              <p>
                We value our clients' input and work closely with them to deliver solutions that exceed their expectations throughout the system lifecycle.
              </p>
            </div>
            <div className="reason-item">
              <h4>🌱 Sustainability</h4>
              <p>
                We are committed to environmentally friendly practices in our product development processes, contributing to a sustainable future.
              </p>
            </div>
            <div className="reason-item">
              <h4>🇮🇳 Make in India</h4>
              <p>
                Proudly aligned with the Make in India initiative, delivering innovation-driven solutions with a strong local focus for the Indian market.
              </p>
            </div>
          </div>
        </div>

        <div className="about-section">
          <h2>💼 Our Value Proposition</h2>
          <div className="about-reasons">
            <div className="reason-item">
              <h4>⚡ Speed to Market</h4>
              <p>
                Translate insights into working prototypes faster, reducing time-to-market and project risk with our rapid development capabilities.
              </p>
            </div>
            <div className="reason-item">
              <h4>🎯 Strategic Execution</h4>
              <p>
                Strategy does not stop at planning. We help clients align commercialization strategy with product development for seamless execution.
              </p>
            </div>
            <div className="reason-item">
              <h4>📈 Scalable Solutions</h4>
              <p>
                Build future-ready, scalable technology platforms that grow with your business needs and adapt to market demands.
              </p>
            </div>
            <div className="reason-item">
              <h4>💰 Cost Efficiency</h4>
              <p>
                Bring complex electronic concepts from idea to reality efficiently and cost-effectively without compromising on quality.
              </p>
            </div>
          </div>
        </div>

        <div className="about-section">
          <h2>🚀 Recent Project Works</h2>
          <ul className="competencies-list">
            <li>Surface Defect Detection for O-rings - Precise solution for identifying surface defects as small as 0.25 mm</li>
            <li>Analog Meter Reading Extraction - AI-ML based solution to extract readings from analog meters</li>
            <li>Microscope Surface Analysis - Specialized image processing software for surface change identification</li>
            <li>Face Detection and Recognition - Attendance system for over 400 clients with Employee Management systems</li>
            <li>AI-based Kid's Companion - Robotic toy for kids aged 5 to 15 years based on AI technology</li>
          </ul>
        </div>
        <div className='team-section'>
          <ul className='team-list'>
            <h2>👥 Meet Our Team</h2>
            <li>
                <Link to="/team">👥 Team</Link>
              </li>  
              </ul>
        </div>
      </div>
    </section>
  );
}

export default About;